import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Config, DatePicker} from '../../../models/config';
import {FormGroup, Validators} from '@angular/forms';
import {DateTimeFormatService} from '../../..';
import * as moment from 'moment';
import {Moment} from 'moment';
import {DateComparable, SetOptions, WidgetPositioning} from 'eonasdan-bootstrap-datetimepicker';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-date-picker',
  templateUrl: './form-date-picker.component.html',
  styleUrls: ['./form-date-picker.component.scss']
})
export class FormDatePickerComponent implements OnInit , OnDestroy {

  config: Config;
  group: FormGroup;
  startDateOptions: SetOptions;
  isAdd: boolean;
  isEdit: boolean;
  isExchange: boolean;
  init: boolean;
  orderType: number;
  dayToExclude: number[];
  // private
  minDate: DateComparable | boolean;
  maxDate: DateComparable | boolean;
  defaultDate: DateComparable;
  useCurrent: boolean;
  endLessDate = false ;
  dateToShow: string;
  widgetPositioning: WidgetPositioning;

  get isDisabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private cdr: ChangeDetectorRef,
              private dateTimeFormatService: DateTimeFormatService) {
    this.dayToExclude = [0, 6];
  }

  ngOnInit(): void {
    this.init = true;
    this.setConfigOptions(this.config.options.datePicker);
    this.setOptions();
    this.setDefaultDate(this.group.get(this.config.controlName[0]).value);
    if ( this.config.options.datePicker.checkboxEndlessModeCheck === true) {
    if (this.config.options.datePicker.checkboxEndlessMode && this.group && !this.isEdit  ) {
      this.endLessDate = true;
      // this.group.get(this.config.controlName[0]).patchValue(moment().format('YYYY-MM-DD'));
      this.group.get(this.config.controlName[0]).enable();
      this.cdr.detectChanges();
    }
    if (this.config.controlName[0] === 'end' &&
      moment(this.group.get(this.config.controlName[0]).value).format('YYYY-MM-DD') === '2099-12-31' &&
      this.config.options.datePicker.checkboxEndlessMode) {
      this.endLessDate = true;
      this.cdr.detectChanges();
    }
    this.group.get([this.config.controlName[0]]).valueChanges.subscribe(val => {
      if (this.group.get(this.config.controlName[0]).disabled &&
          moment(this.group.get(this.config.controlName[0]).value).format('YYYY-MM-DD') === '2099-12-31') {
          this.endLessDate = true;
      }
    })
    }
    if ( this.config.options.datePicker.checkboxEndlessModeCheck === false) {
      this.endLessDate = false;
    }
  }

  ngOnDestroy(): void {
    this.endLessDate = false
  }

  setDefaultDate(date: string): void {
    if (date && date !== 'Invalid date') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        this.defaultDate = moment(date, 'YYYY-MM-DD');
      }
      else if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
        this.defaultDate = moment(date, 'DD/MM/YYYY');
      }
      else {
        this.defaultDate = moment(date);
      }
      this.setOptions();
      this.group.markAsDirty(); // used to enable save button when date prefilled
    }
  }

  setConfigOptions(config: DatePicker): void {
    if (this.orderType === 4) { // if exchange re init number of delay 1
      this.config.options.datePicker.numberDelayDays = 1;
    }
    this.minDate = config.minDate === true
      ? this.getMinDateExcludeWeekEnd(moment().add(this.config.options.datePicker.numberDelayDays, 'days'))
      : false;
    this.useCurrent = config.useCurrent;
    if (this.isEdit) {
      this.defaultDate = this.group.get(this.config.controlName[0]).value;
    } else {
      this.defaultDate = config.defaultDate === true
        ? this.getMinDateExcludeWeekEnd(moment().add(this.config.options.datePicker.numberDelayDays, 'days'))
        : null;
    }
    if (this.defaultDate && !this.isMinDateIfBeforeDefaultDate()) {
      this.minDate = this.defaultDate;
    }
    if (config.daysOfWeekDisable !== null && config.daysOfWeekDisable !== undefined) {
      if (!config.daysOfWeekDisable) {
        this.dayToExclude = [];
      }
    }

    if (config.widgetPositioning) {
      this.widgetPositioning = config.widgetPositioning;
    }

    this.maxDate = config.maxDate === true
      ? (moment().add(this.config.options.datePicker.numberMaxDays, 'days'))
      : config.maxDate;
  }

  isMinDateIfBeforeDefaultDate(): boolean {
    if (typeof this.minDate !== 'boolean') {
      return moment(this.defaultDate).isAfter(this.minDate)
    }
    return true;
  }

  /**
   * @param: Moment
   * If param is after 15h && is exchange ? ad 1 day
   * If param is in weekend ? add 1 or 2 day to be not
   */
  getMinDateExcludeWeekEnd(date: Moment): Moment {
    let tempDate = this.checkIfAfter15hForExchange(date).startOf('day');
    if (this.getDayFromDate(date) === 6) { // Saturday
      tempDate = date.add(2, 'days')
    } else if (this.getDayFromDate(date) === 0) { // Sunday
      tempDate = date.add(1, 'days')
    }
    return tempDate
  }

  checkIfAfter15hForExchange(date: Moment): Moment {
    const tempDate = date;
    const hourOfDay = moment().hour();
    if (this.orderType === 4 && hourOfDay > 14) {
      tempDate.add(1, 'days')
    }
    return tempDate;
  }

  /**
   0 = Sunday
   1 = Monday
   2 = Tuesday
   3 = Wednesday
   4 = Thursday
   5 = Friday
   6 = Saturday
   */
  getDayFromDate(date: Moment): number {
    return +date.day();
  }

  setOptions(): void {
    this.startDateOptions = this.dateTimeFormatService.buildDateTimePickerOptions({
      format: DateTimeFormatService.input.date,
      enabledDates: this.config.options.datePicker.enabledDates,
      minDate: (typeof this.minDate !== 'boolean') ? moment(this.minDate) : this.minDate,
      maxDate: (typeof this.maxDate !== 'boolean') && (this.maxDate !== undefined) ? moment(this.maxDate) : false,
      daysOfWeekDisabled: this.dayToExclude,
      debug: false,
      disabledDates: this.config.options.datePicker.disabledDates,
      extraFormats: ['DD/MM/YYYY'],
      useCurrent: !this.isEdit ? this.useCurrent : false,
      defaultDate: (this.defaultDate && typeof this.defaultDate !== 'boolean') ? moment(this.defaultDate) : this.defaultDate,
      widgetPositioning: this.widgetPositioning
    });
  }

  getDate(date: string): void {
    if (!this.defaultDate || !this.minDate) {
       this.setConfigOptions(this.config.options.datePicker);
    }
    const formDateValue = this.group.get(this.config.controlName[0]).value;
    if (!date && formDateValue) {
      this.setOptions();
    } else if (this.isDateSettable()) { //  exchange
      this.dateToShow = date;
      this.group.markAsDirty(); // used to enable save button when date prefilled
    } else if (this.isEdit) { // edit
      this.setDefaultDate(formDateValue);
    }
  }

  isDateSettable(): boolean {
    return !this.dateToShow && !this.isAdd && this.config.presentation !== 'filter'
  }


  // tslint:disable-next-line:no-any
  checkboxChange(event: any): void {
    if (event.target.checked) {
      this.endLessDate = true;
      if ( this.config.options.datePicker.checkboxEndlessModeCheck === true) {
        this.group.get(this.config.controlName[0]).clearValidators();
        this.group.get(this.config.controlName[0]).updateValueAndValidity();
      }
      this.group.get(this.config.controlName[0]).patchValue(null);
      this.group.get(this.config.controlName[0]).disable();
    } else {
      this.endLessDate = false;
      this.group.get(this.config.controlName[0]).enable();
      if ( this.config.options.datePicker.checkboxEndlessModeCheck === true) {
        this.group.get(this.config.controlName[0]).setValidators([Validators.required]);
        this.group.get(this.config.controlName[0]).updateValueAndValidity();
      }
      if (moment(this.group.get(this.config.controlName[0]).value).format('YYYY-MM-DD') === '2099-12-31' ||
        !this.group.get(this.config.controlName[0]).value) {
        // this.group.get(this.config.controlName[0]).patchValue(moment().format('YYYY-MM-DD'));
        this.cdr.detectChanges();
      }
    }

  }

}
